<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" :title="title" @hidden="clearModalData">
    <div v-if="file">
      <div v-if="file.type === 'image' && file.mime_type.indexOf('image') === 0">
        <b-img :src="file.file_url" fluid></b-img>
      </div>
      <div v-if="file.type === 'video' && file.mime_type.indexOf('video') === 0">
        <b-embed type="video" controls>
          <source :src="file.file_url" :type="file.mime_type">
        </b-embed>
      </div>
      <div v-if="file.type === 'url'">
        <b-embed type="iframe" :src="file.path">
        </b-embed>
      </div>
    </div>
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-spinner v-if="formLoading" label="Items loading"></b-spinner>
      <span v-if="allPlaylists.length > 0">
        <span>Playlists: </span>
        <span v-for="(playlist, $index) in allPlaylists" :key="`${playlist.type}-${playlist.id}`">
          <b-link :to="{ name: playlist._route, params: { id: playlist.id } }">{{ playlist.name }}</b-link>{{ $index ===
            allPlaylists.length - 1 ? '' : ', ' }}
        </span>
      </span>
      <div class="float-right">
        <FileNeededToggle v-if="file" :file="file" @is-needed-updated="(newValue) => {this.file.is_needed = newValue}"/>
        <b-button variant="primary" class="mx-2" @click="modalConfirm">Close</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mediaMixin from '@/views/admin/media/mediaMixin';
import FileNeededToggle from '../misc/FileNeededToggle.vue';

export default {
  mixins: [mediaMixin],
  components: {FileNeededToggle},
  data() {
    return {
      title: '',
      body: '',
      file: null,
      filePlaylists: null
    };
  },
  created() {
    this.$root.$on('modal-show-file-preview', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-file-preview', this.showModal);
  },
  computed: {
    totalPlaylistsCount() {
      const count = 0 + (this.file.playlists_count ?? 0) + (this.file.loop_playlists_count ?? 0) + (this.file.weekly_playlists_count ?? 0);
      return count;
    },
    allPlaylists() {
      const playlists = [];
      if (this.filePlaylists) {
        playlists.push(
          ...this.filePlaylists.playlists?.map(p => ({ ...p, _route: 'showPlaylist' })) ?? [],
          ...this.filePlaylists.loopPlaylists?.map(p => ({ ...p, _route: 'showLoopPlaylist' })) ?? [],
          ...this.filePlaylists.weeklyPlaylists?.map(p => ({ ...p, _route: 'showWeeklyPlaylist' })) ?? []
        );
      }
      return playlists;
    }
  },
  methods: {
    showModal({
      title,
      body,
      file,
    }) {
      this.title = title;
      this.body = body;
      this.file = file;
      if (this.totalPlaylistsCount > 0) {
        this.getFilePlaylists(this.file)
          .then((data) => this.filePlaylists = data)
          .catch(() => { });
      }
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.title = null;
      this.body = null;
      this.file = null;
    },
    modalConfirm() {
      this.hideModal();
    },
  },
};
</script>
